/* eslint-disable import/prefer-default-export */
import { createAction } from '@reduxjs/toolkit';
import { Theme } from '../../design_system';

export const setTheme = createAction('theming/setTheme', (theme: Theme) => ({
  payload: theme,
}));
